exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\nsvg[data-v-d0720302] {\n  height: 30px;\n  width: 30px;\n}\nsvg path[data-v-d0720302] {\n    fill: #0D79F2;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Partials/SVG/ServiceDog.vue"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,YAAY;CACb;AACD;IACI,cAAc;CACjB","file":"ServiceDog.vue","sourcesContent":["\nsvg[data-v-d0720302] {\n  height: 30px;\n  width: 30px;\n}\nsvg path[data-v-d0720302] {\n    fill: #0D79F2;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d0720302","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Partials/SVG/ServiceDog.vue
// module id = 1277
// module chunks = 0